import FeaturedArtistSlots from '../components/FeaturedArtistSlots';

export default function FeaturedArtistsSection({
    featuredArtists = [],
    slotCount = 6,
}) {

    return (
        <>
            <div className="bjnt-section-header">
                <div>
                    <h2 className="bjnt-section-title">
                        Featured Artists
                    </h2>
                </div>

                <a
                    href="mailto:advertise@bajantube.com?subject=Featured%20Artist%20Slot"
                    className="bjnt-playlist-play"
                >
                    Get Featured
                </a>
            </div>

            <FeaturedArtistSlots
                artists={featuredArtists}
                slotCount={slotCount}
            />
        </>
    );
}